import { z } from "zod";
import { patientGroupSchema } from "./patient-group";
import { CONFIRM_PRESCRIPTION_CHOICES } from "./treatment-start";

// TES-1150 (Emelie 2026-10-07) — the operational list
// "Recept utfärdat – inväntar abonnemangsaktivering": the patients whose
// doctor has finished the medical case (decision, journal, prescription) and
// whose subscription is not yet verified, so the prescription has not been
// released to them.
//
// "Listan bör visa: patient, patienttyp, behandlingsbeslutsdatum,
// receptutfärdandedatum, vald abonnemangsnivå när sådan finns,
// aktiveringsstatus, och senaste aktiveringspåminnelse."
// "Dessa patienter ska inte framställas som medicinskt ofärdiga. Listan är
// till för administrativ uppföljning och påminnelser."
//
// A row is identity and administrative state only: no form answer, journal
// text, ordination or medical reasoning. Admin roles only (the contact
// list's rule, TES-1109), and the API logs a read of each patient it names.

export const awaitingActivationRowSchema = z.object({
  patientId: z.string(),
  patientName: z.string(),
  patientGroup: patientGroupSchema,
  /** The newest published positive decision (CP-09, or the transfer review). */
  decidedAt: z.string().nullable(),
  /** The doctor's registration of the prescription. */
  prescriptionRegisteredAt: z.string(),
  prescriptionChoice: z.enum(CONFIRM_PRESCRIPTION_CHOICES).nullable(),
  /** The plan the newest subscription link carries, when one does. */
  plan: z.string().nullable(),
  /** The subscription status the webhook stored ("none" without a row). */
  subscriptionStatus: z.string(),
  /**
   * The newest activation reminder: the newest subscription link e-mail,
   * whether the doctor's first send, his re-send or her own "Skicka
   * informationen igen".
   */
  lastReminderAt: z.string().nullable(),
});
export type AwaitingActivationRow = z.infer<typeof awaitingActivationRowSchema>;

export const awaitingActivationListSchema = z.object({
  rows: z.array(awaitingActivationRowSchema),
});
export type AwaitingActivationList = z.infer<
  typeof awaitingActivationListSchema
>;
